import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { useNavigate } from "react-router-dom";
import { customStyles } from '../../tableStyles';
import axios from 'axios';
import '../css/CommitteeList.css';
import '../css/CrmSearchBar.css';
import '../css/EmailCopyControl.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { formatOrgTypesLabel, orgHasOrgTypeLabel } from "../../utils/orgTypeHelpers";
import { DataTableLoader, GoldLoader } from "../shared/Loaders";

function CommitteeList() {
  const [loading, setLoading] = useState(true);
 
  const [committees, setCommittees] = useState([]);
  const [filteredCommittees, setFilteredCommittees] = useState([]);

  const navigate = useNavigate();
  // const [orgTypes, setOrgTypes] = useState({});
  const [searchTerm, setSearchTerm] = useState('');

  // Fetch organisation and orgType data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const orgResponse = await axios.get(`${process.env.REACT_APP_API_URL}/organisations`);
        // Fetch organisations with org_type_id === '3'
        const committeesData = orgResponse.data.filter((item) => orgHasOrgTypeLabel(item.org_type_id, "Committee"));

        setCommittees(committeesData);
        setFilteredCommittees(committeesData); 
        //setOrgTypes(orgTypesMap);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    
    const filtered = committees.filter((committee) =>
  (committee.name || "").toLowerCase().includes(value) ||
  (committee.email || "").toLowerCase().includes(value) ||
  formatOrgTypesLabel(committee.org_type_id).toLowerCase().includes(value)
);

setFilteredCommittees(filtered);
};

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert("Email copied to clipboard !")
  }
  
  // Define columns for DataTable
  const columns = [
    {
      name: "#",
      cell: (row, index) => index + 1,
      width: "60px",
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },    
    {
      name: 'Logo',
      selector: row => row.logo,
      cell: row => (
        <img
          src={row.logo ? `/images/${row.logo}` : '/images/org_logo1.png'}
          alt={row.name}
          style={{ width: '48px', height: '40px', borderRadius: '4px' }}
        />
      ),
      width: '120px',
      ignoreRowClick: true,
      allowOverflow: true,
      sortable: false,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      width : '420px',
      cell: (row) => (
        <button
          type="button"
          className="btn btn-link p-0 text-decoration-none"
          onClick={() => navigate(`/organisation/${row._id}`, { state: { organisation: row } })}
        >
          {row.name}
        </button>
      ),
      sortable: true,
    },
    {
    name: "Shortname",
    selector: row => row.shortname || "—",
    sortable: true,
    },
    { 
      name: 'Org. Type', 
      selector: (row) => formatOrgTypesLabel(row.org_type_id), 
      sortable: true 
    },  
    {
  name: 'Email',
  selector: (row) => row.email,
  sortable: true,
  cell: (row) => (
    <div className="email-copy-cell">
      <span className="email-text">{row.email || "-"}</span>
     {row.email && (
      <button
        type="button"
        className="email-copy-btn"
        onClick={(e) => {
          e.stopPropagation();
          copyToClipboard(row.email);
        }}
        title="Copy Email"
      >
        <FontAwesomeIcon icon={faCopy} style={{ color: '#D9A128' }} />
      </button>
     )}
    </div>
  )
  },  
  {
    name: "Phone",
    selector: row => row.phone || "—",
    sortable: true,
  },

  {
    name: "Country",
    selector: row => row.country_id?.name || "—",
    sortable: true,
  },

  {
    name: "City",
    selector: row => row.city || "—",
    sortable: true,
  },

  { name: 'Active', selector: row => row.active ? 'Yes' : 'No', sortable: true },
  ];

  if (loading && committees.length === 0) {
    return <GoldLoader label="Loading..." variant="page" />;
  }

  return (
    <div className="crm-list-page">
      <div className="crm-list-toolbar d-flex justify-content-between mb-1">
        <div className="w-25 me-3 mb-1">
          <div className="crm-search-wrapper">
            <FontAwesomeIcon icon={faMagnifyingGlass} className="crm-search-icon" />
            <input
              type="text"
              placeholder="Search by name"
              className="crm-search-input form-control search-input"
              value={searchTerm}
              onChange={handleSearch}
              title="Search committees"
            />
          </div>
        </div>  
    </div>
      <div className= "crm-comm-table-wrapper">
      <DataTable
        columns={columns}
        data={filteredCommittees}
        progressPending={loading}
        progressComponent={<DataTableLoader />}
        pagination
        paginationPerPage={50}
        paginationComponentOptions={{ noRowsPerPage: true }}
        striped
        responsive
        customStyles={customStyles} // Apply custom styles
      />
      </div>
    </div>
  );
}

export default CommitteeList;
